export default __webpack_public_path__ + "static/media/user_back.58ec6503.svg";